<template>
    <div class="studentIntro">
        <div class="top-header">
            <div class="title">选择购买</div>
            <div class="goQuanyi" @click="closeOpenMember()">
                <span>了解权益</span>
                <img class="left-arrow" src="~@/assets/left-arrow.png" alt="" />
            </div>
        </div>
        <div class="intro">
            <div v-html="saleInfo.introduce"></div>
        </div>
        <div class="footer">
            <div
                class="priceBox"
                :class="[index == 0 ? 'active' : '']"
                @click="chagePrice(0)"
            >
                <div class="youhui">年费特惠</div>
                <div class="date">12个月</div>
                <div class="price">
                    <span>￥</span>
                    <span class="sale-price">{{ saleInfo.price }}</span>
                </div>
                <div class="origin-price">￥{{ saleInfo.originalPrice }}</div>
            </div>
            <div
                class="priceBox"
                :class="[index == 1 ? 'active' : '']"
                v-if="free.ifFirstTime"
                @click="chagePrice(1)"
            >
                <div class="youhui">限时免费体验</div>
                <div class="date">{{ free.day }}天</div>
                <div class="price">
                    <span>￥</span>
                    <span class="sale-price">0.00</span>
                </div>
                <div class="origin-price">￥{{ free.price }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import payService from "../../service/pay.service";
export default {
    name: "studentIntro",
    props: ["free", "index"],
    data() {
        return {
            saleInfo: {},
        };
    },
    created() {
        this.getPriceConfig();
    },
    methods: {
        chagePrice(index) {
            this.$emit("changePrice", index);
        },
        getPriceConfig() {
            payService.getPriceConfig().then((res) => {
                this.saleInfo = res.data;
            });
        },
        closeOpenMember() {
            this.$emit("closeStudentIntro");
        },
    },
};
</script>

<style lang="scss" scoped src="./studentIntro.scss">
</style>